import {Component, Input} from '@angular/core';
import {BrSiebenTageWetterbericht} from '../../../../../../../model/vorhersagen/br-wetterbericht';

@Component({
  selector: 'app-br-siebentagewetter-bericht',
  templateUrl: './br-siebentagewetter-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class BrSiebentagewetterBerichtComponent {
  @Input() siebentageWetterbericht: BrSiebenTageWetterbericht;
}
